<template>
  <div class="rangePage">
    <el-row class="mb20" :gutter="20" type="flex" justify="space-between">
      <el-col>
        <el-button size="small" type="primary" v-show="$ButtonShow('YHL_ADD_02')" @click="saveRange">保存围栏</el-button>
        <el-button size="small" type="primary" v-show="$ButtonShow('YHL_ADD_02')"
          @click="clearSelectPolygon">清除选中的围栏</el-button>
        <el-button size="small" type="primary" v-show="$ButtonShow('YHL_ADD_02')" @click="clearRange">清除区域围栏</el-button>
      </el-col>
      <el-col style="width: 400px;text-align: right;">
        <el-form class="global-form" :model="projectInfo" :inline="true">
          <el-form-item label="地区搜索" style="margin: 0;">
            <el-autocomplete size="small" v-model="projectInfo.projectAddr" style="width: 200px;"
              :fetch-suggestions="addrFetch" placeholder="请搜索并选择位置" @select="addrChange" :maxlength='50'>
              <template slot-scope="{ item }">
                <span>{{ item.name }}</span>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="rangeMap">
      <div id="rangeMapContainer"></div>
      <div class='rangeMapOperation'>
        <el-button-group>
          <el-button :class="[{ 'isActive': !isDraw && !isAct }]" type="primary" @click="closed">
            <span class="iconfont icon-icon_map_tuodong"></span>
          </el-button>
          <el-button :class="[{ 'isActive': isDraw }]" type="primary" @click="openDraw">
            <span class="iconfont icon-icon_map_dianziweilan1"></span>
          </el-button>
          <el-button :class="[{ 'isActive': isAct }]" type="primary" @click="openisAct">
            <span class="iconfont icon-zhongxindian"></span>
          </el-button>
        </el-button-group>
      </div>
    </div>
    <div class="layer">
      <div :class="{ active: currentIndex === 0 }" @click="changeLayer(0)">2D</div>
      <div :class="{ active: currentIndex === 1 }" @click="changeLayer(1)">卫星</div>
    </div>
  </div>
</template>

<script>
import { drawPolygon } from '@/utils/formatData'
import LocationImg from '@/assets/img/icon_address.png'
const polygonCurrentStyle = {
  strokeColor: '#9D4DFF',
  fillColor: '#9D4DFF',
  strokeWeight: 4,
  strokeOpacity: 1,
  fillOpacity: 0.5,
  strokeStyle: 'solid',
  cursor: 'pointer',
  zIndex: 1000
}
const polygonSelectStyle = {
  strokeColor: '#FF402B',
  fillColor: '#FF402B',
  strokeWeight: 4,
  strokeOpacity: 1,
  fillOpacity: 0.5,
  strokeStyle: 'solid'
}
export default {
  name: 'List',
  components: {
  },
  data() {
    return {
      isDraw: false,
      isAct: false,
      projectInfo: {},
      projectLocation: [],
      areaLocation: [],
      map: null,
      mouseTool: null,
      overlays: [],
      selectPolygon: { ind: -1, polygon: null },
      marker: [],
      currentIndex: 0
    }
  },
  computed: {
  },
  created() {
    this.getProjectInfo()
  },
  methods: {
    // 获取项目信息
    getProjectInfo() {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: this.$route.query.projectId
      }).then((res) => {
        if (res) {
          this.projectInfo = res
          this.projectLocation = this.projectInfo.locationList || []
          const lng = Number(this.projectInfo.longitude)
          const lat = Number(this.projectInfo.latitude)
          this.$nextTick(() => {
            this.initMap(lng, lat)
          })
        } else {
          this.$message.error('未获取到项目信息')
        }
      })
    },
    // 详细地址输入
    addrFetch(queryString, cb) {
      AMap.plugin(['AMap.AutoComplete'], () => {
        // 实例化Autocomplete
        const autoComplete = new AMap.AutoComplete({
          city: this.projectInfo.projectArea
        })
        autoComplete.search(this.projectInfo.projectArea + queryString, (status, result) => {
          if (status === 'complete') {
            cb(result.tips)
          }
        })
      })
    },
    // 点击详细地址下拉
    addrChange(data) {
      this.projectInfo.projectAddr = data.name
      this.projectInfo.latitude = data.location.getLat().toString()
      this.projectInfo.longitude = data.location.getLng().toString()
      this.map.setCenter([Number(this.projectInfo.longitude), Number(this.projectInfo.latitude)])
    },
    // 初始化地图
    initMap(lng, lat) {
      AMap.plugin(['AMap.MouseTool'], () => {
        this.map = new AMap.Map('rangeMapContainer', {
          center: [lng, lat],
          zoom: 15
        })
        this.addMarker(lng, lat)
        // 画项目电子围栏
        this.overlays = drawPolygon(this.map, this.projectLocation, polygonCurrentStyle, this.polygonClick)
        this.mouseTool = new AMap.MouseTool(this.map)
        this.mouseTool.on('draw', (e) => {
          // 面积计算，清除掉面积为0的非围栏所绘线条，四舍五入，面积小于0.5平方米的也舍弃
          const area = Math.round(AMap.GeometryUtil.ringArea(e.obj.getPath()))
          if (area > 0) {
            this.overlays.push(e.obj)
          } else {
            this.map.remove(e.obj)
            this.$message.warning('当前所画图形面积为0，无法保存。')
          }
        })
      })
    },
    addMarker(lng, lat) {
      this.map.remove(this.marker)
      this.marker = []
      const marker = new AMap.Marker({
        map: this.map,
        position: new AMap.LngLat(lng, lat),
        offset: new AMap.Pixel(-20, -10),
        icon: LocationImg
      })
      this.marker.push(marker)
      this.map.add(marker)
      this.map.setCenter([lng, lat])
    },
    polygonClick(e) {
      const ind = this.overlays.findIndex(item => item.contains(e.lnglat))
      if (ind >= 0) {
        if (!this.isAct) {
          this.selectPolygon.polygon && this.selectPolygon.polygon.setOptions(polygonCurrentStyle)
          this.selectPolygon.ind = ind
          this.selectPolygon.polygon = this.overlays[ind]
          this.selectPolygon.polygon.setOptions(polygonSelectStyle)
        } else {
          this.lnglatClick(e)
        }
      }
    },
    // 地图操作鼠标项
    closed() {
      this.isDraw = false
      this.isAct = false
      this.mouseTool.close()
      this.overlays.forEach(item => {
        item.on('click', this.polygonClick)
      })
    },
    // 地图操作电子围栏
    openDraw() {
      this.overlays.forEach(item => {
        item.off('click', this.polygonClick)
      })
      this.isDraw = true
      this.isAct = false
      this.mouseTool.polygon(polygonCurrentStyle)
    },
    // 地图操作中心点
    openisAct() {
      this.isDraw = false
      this.isAct = true
      this.mouseTool.close()
      this.selectPolygon.polygon && this.selectPolygon.polygon.setOptions(polygonCurrentStyle)
      this.overlays.forEach(item => {
        item.on('click', this.polygonClick)
      })
      this.map.on('click', this.lnglatClick)
    },
    // 鼠标点击中心点
    lnglatClick(e) {
      if (this.isAct && e.lnglat.lng && e.lnglat.lat) {
        this.addMarker(e.lnglat.lng, e.lnglat.lat)
        this.$confirm('是否更新当前项目中心点', '更新', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitCenter(e.lnglat.lng, e.lnglat.lat)
        }).catch(() => {
          this.addMarker(Number(this.projectInfo.longitude), Number(this.projectInfo.latitude))
        })
      }
    },
    // 保存中心点
    submitCenter(lng, lat) {
      this.$axios.post(this.$apis.project.updateYhProjectMap, {
        projectId: this.$route.query.projectId,
        longitude: lng,
        latitude: lat
      }).then(() => {
        this.$message.success('更新中心点成功！')
      })
    },
    // 保存围栏
    saveRange() {
      if (this.overlays.length === 0) {
        this.$message('请至少画出一个项目围栏再做保存')
      } else {
        const location = []
        this.overlays.forEach((item) => {
          const lng = []
          const lat = []
          const path = item.getPath()
          path.forEach((cItem) => {
            lng.push(cItem.lng)
            lat.push(cItem.lat)
          })
          location.push({
            latitude: lat,
            longitude: lng
          })
        })
        this.$axios.post(this.$apis.project.insertAllYhLocation, {
          objectId: this.$route.query.projectId,
          locations: location
        }).then(() => {
          this.$message.success('添加围栏成功')
        })
      }
    },
    // 清除选中的围栏
    clearSelectPolygon() {
      if (this.selectPolygon.ind >= 0) {
        this.$confirm('确定要删除选中的围栏？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.removePolygon()
        })
      }
    },
    // 从数组中清除选中的电子围栏
    removePolygon() {
      this.$message.success('删除围栏成功')
      this.map && this.map.remove(this.selectPolygon.polygon)
      this.overlays.splice(this.selectPolygon.ind, 1)
      this.selectPolygon = { ind: -1, polygon: null }
    },
    // 清除所有围栏
    clearRange() {
      this.$confirm('确定要删除所有围栏？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除围栏成功')
        this.map && this.map.remove(this.overlays)
        this.overlays = []
      })
    },
    changeLayer(value) {
      this.currentIndex = value
      this.map.setLayers([])
      if (value === 0) {
        // 添加标准地图图层
        this.map.setMapStyle('amap://styles/normal')
        this.map.add(new AMap.TileLayer())
      } else {
        // 添加卫星地图图层
        this.map.add(new AMap.TileLayer.Satellite())
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/color";

.rangePage {
  background-color: white;
  width: 100%;
  height: calc(100% - 100px);
  min-height: 686px;

  ::v-deep .el-card__body {
    height: 100% !important;
  }

  .rangeMap {
    position: relative;
    // height: 100%;
    height: 640px;

    #rangeMapContainer {
      height: 100%;
    }

    .rangeMapOperation {
      position: absolute;
      top: 20px;
      left: 20px;

      .el-button-group {
        border: 1px solid $color-default;
        border-radius: 3px;

        .el-button {
          width: 64px;
          height: 46px;
          background-color: #fff;

          span {
            font-size: 28px;
            color: $color-default;
          }

          &.isActive {
            background-color: $color-default;

            span {
              color: #fff;
            }
          }
        }
      }
    }
  }
}

.layer {
  display: flex;
  position: absolute;
  right: 60px;
  bottom: 60px;
  z-index: 99999;
  background: #FFFFFF;
  font-size: 12px;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 32px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    &.active {
      background: var(--color-primary);
      color: #ffffff;
    }
  }
}
</style>
